import { raise } from '@vy/utils';
import { useContext } from 'react';
import { IntegrationsContext } from '../NEW-integrations-page-components/IntegrationsContextProvider';

export const useIntegrationContextProvider = () => {
  const context = useContext(IntegrationsContext);

  if (!context) {
    raise(new Error('useIntegrationContextProvider must be used within an IntegrationsContextProvider'));
  }

  return context;
};
